(()=>{
const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
function init(root=document){
 root.querySelectorAll('.surfaces').forEach(section=>{
  if(section.dataset.ready)return;section.dataset.ready='true';
  section.addEventListener('click',event=>{
   const choice=event.target.closest('.surface-choice');if(!choice)return;
   section.querySelectorAll('.surface-choice').forEach(button=>{const active=button===choice;button.classList.toggle('is-selected',active);button.setAttribute('aria-pressed',String(active));});
   const tip=section.querySelector('[data-surface-tip]');if(tip){tip.textContent=choice.dataset.tip;if(!reduced.matches)tip.animate([{opacity:0,transform:'translateY(3px)'},{opacity:1,transform:'translateY(0)'}],{duration:220,easing:'ease-out'});}
  });
 });
 if(!reduced.matches&&'IntersectionObserver' in window){
  const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('reveal-ready');observer.unobserve(entry.target);}});},{threshold:.12});
  root.querySelectorAll('.section-heading,.benefit,.steps article,.faq>div,.offer-ticket,.cta h2').forEach(el=>observer.observe(el));
 }
}
init();document.addEventListener('shopify:section:load',event=>init(event.target));
const header=document.querySelector('.header');let scheduled=false;
window.addEventListener('scroll',()=>{if(scheduled||!header)return;scheduled=true;requestAnimationFrame(()=>{header.classList.toggle('is-scrolled',window.scrollY>60);scheduled=false;});},{passive:true});
document.addEventListener('submit',event=>{const form=event.target;if(!form.matches('.purchase-form'))return;const button=form.querySelector('button[type="submit"]');if(button){button.setAttribute('aria-busy','true');setTimeout(()=>button.removeAttribute('aria-busy'),6000);}});
})();
